import Model from 'modules/reports/orm/Model'
import Group from 'modules/reports/models/Group'
import User from 'modules/reports/models/User'
import formatDate from 'modules/reports/utils/format/formatDate'

export default class Report extends Model {
  id: number
  name: string
  group_id: number
  scheduled: boolean
  last_run_at: string
  created_by_user_id: number

  get formattedLastRunAt() {
    return formatDate(this.last_run_at)
  }

  get group(): Group {
    return this.belongsTo(Group, this.group_id)
  }

  get createdByUser(): User {
    return this.belongsTo(User, this.created_by_user_id)
  }
}
